// Can't have it with globals or globals will be called in viewer which we don't want
// List all the interface (contents, pointofviews and plugins) used to import and export project
/**
 * @ignore Property Rights, ThreedJson
 */
export const projectInterface: any = {};

export const EXPORT_FILTER_PREFIX = 'editor_';
